export const environment = {
    okta: {
        issuer: 'https://marsh.okta.com/oauth2/default',
        clientId: '0oa1unwnk67MG96Jq358',
        redirectUri: window.location.origin + '/LoginCallback',
        postLogoutRedirectUri: window.location.origin + '/LogoutCallback',
        scopes: ['openid', 'profile', 'email'],
        pkce: true
    },
    allowedOrigins: ['https://credi-link.africa.marsh.com'],
    apiBaseUrl: 'https://app-credilink-primary-san-api.azurewebsites.net'
};